import classNames from "classnames";

import { StatusVariant } from "./integrationMessageUtils";

import "./IntegrationMessageStatus.css";

type IntegrationMessageStatusProps = {
  statusText: string;
  statusVariant: StatusVariant;
};

const IntegrationMessageStatus = ({
  statusText,
  statusVariant,
}: IntegrationMessageStatusProps) => {
  if (!statusText) return null;

  return (
    <span
      className={classNames(
        "IntegrationMessageStatus",
        `IntegrationMessageStatus--${statusVariant}`
      )}
    >
      {statusText}
    </span>
  );
};

export default IntegrationMessageStatus;
